import { AText } from '@alf/uikit';
import { SPORT_IDS as SPORTS_IDS } from '../../../../../../constants';
import { useEventFields } from '../../../../../../store';

const EventStateLabel = ({ eventId, labelText, eventTime }) => {
  const {
    eventResultName,
    canceled = false,
    finished = false,
    inprogress = false,
    isCachedEvent,
    sportId
  } = useEventFields({
    eventId,
    fields: [
      'eventResultName',
      'canceled',
      'finished',
      'inprogress',
      'isCachedEvent',
      'sportId'
    ]
  });

  const renderLabel = () => {
    switch (sportId) {
      case SPORTS_IDS.PICKLEBALL: {
        return eventResultName;
      }
      default: {
        return labelText || eventResultName;
      }
    }
  };

  return finished || inprogress || canceled || isCachedEvent ? (
    <AText size="s" breed="R" color="line_txt_1">
      {eventTime}
    </AText>
  ) : (
    <AText size="s" breed="R" color="line_txt_1">
      {renderLabel()}
    </AText>
  );
};

export default EventStateLabel;
